import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import './App.css'
import AnimationLoop from './animationLoop/animationLoop.tsx'
import LeftTextRightWidget from './leftTextRightWidget/leftTextRightWidget.tsx'
import Header from './header/Header'
import Features from './features/Features'
import AdvantagesModule from './advantages/AdvantagesModule.tsx'
import PrivacyPolicy from './legal/PrivacyPolicy.tsx'
import TermsConditions from './legal/TermsConditions.tsx'
import DerechosArco from './legal/DerechosArco.tsx'
import Footer from './footer/Footer'

const AnnouncementDialog = lazy(
  () => import('./announcementDialog/AnnouncementDialog')
)

function HomePage() {
  return (
    <>
      <Suspense fallback={null}>
        <AnnouncementDialog />
      </Suspense>
      <Header />
      <LeftTextRightWidget />
      <Features />
      <AdvantagesModule />
      <AnimationLoop fileName="animation3.json" />
      <Footer />
    </>
  )
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/politicas_de_privacidad" element={<PrivacyPolicy />} />
      <Route path="/terminos_y_condiciones" element={<TermsConditions />} />
      <Route path="/derechos-arco" element={<DerechosArco />} />
    </Routes>
  )
}

export default App
